<article>
  <h3 *ngIf="data.header" class="d-flex align-items-center">
    <span>{{ data.header }}</span>
  </h3>

  <div class="notifier-content">
    <div *ngIf="data.message">{{ data.message }}</div>
  </div>

  <div class="notifier-action">
    <button
      mat-button
      class="notifier-dismiss"
      *ngIf="data.showDismissAction"
      (click)="snackBarRef.dismiss()"
    >
      dismiss
    </button>
    <button
      mat-raised-button
      [color]="data.confirmButtonColor"
      (click)="snackBarRef.dismissWithAction()"
      *ngIf="data.showButton"
    >
      {{ data.confirmButtonText }}
    </button>
  </div>
</article>
